import { Typography } from '../../../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT } from '../../../../../constants'

export const EmptyStateForNonHospitalUser = ({
  openPopup,
  isReadonlyState = false
}: {
  openPopup: VoidFunction
  isReadonlyState?: boolean
}) => {
  return (
    <div className="survey-results__not-responded-empty gap-8 column align-center justify-center">
      <Typography.Headline6>User has not responded</Typography.Headline6>
      <Typography.Body1>
        {isReadonlyState
          ? 'No selection has been made for this category.'
          : 'Click "Vote" to record a response on their behalf.'}
      </Typography.Body1>
      {!isReadonlyState && (
        <Button type={BUTTON_TYPES.PRIMARY} upperCase small onClick={openPopup}>
          {BTN_TXT.VOTE}
        </Button>
      )}
    </div>
  )
}
